import { useCallback, useState } from 'react';
import { useUniqueNativeID } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const useProductDetailsTabs = (params: Params) => {
  const { hasSuperIngredients } = params;

  const initialTab = hasSuperIngredients ? TABS.SUPER_INGREDIENTS : TABS.NUTRITION; // prettier-ignore

  // ─── State ───────────────────────────────────────────────────────────

  const [activeTabId, setActiveTabId] = useState(initialTab);

  // ─── Helpers ─────────────────────────────────────────────────────────

  const setActiveTabToSuperIngredients = useCallback(() => {
    setActiveTabId(TABS.SUPER_INGREDIENTS);
  }, []);

  const setActiveTabToNutrition = useCallback(() => {
    setActiveTabId(TABS.NUTRITION);
  }, []);

  // ─────────────────────────────────────────────────────────────────────

  const isSuperIngredientsTabActive = activeTabId === TABS.SUPER_INGREDIENTS;
  const isNutritionTabActive = activeTabId === TABS.NUTRITION;
  const superIngredientsNativeId = useUniqueNativeID(TABS.SUPER_INGREDIENTS);
  const superIngredientsPanelNativeId = useUniqueNativeID(`${TABS.SUPER_INGREDIENTS}_PANEL`); // prettier-ignore
  const nutritionNativeId = useUniqueNativeID(TABS.NUTRITION);
  const nutritionPanelNativeId = useUniqueNativeID(`${TABS.NUTRITION}_PANEL`);

  // ─────────────────────────────────────────────────────────────────────

  return {
    isSuperIngredientsTabActive,
    isNutritionTabActive,
    superIngredientsNativeId,
    superIngredientsPanelNativeId,
    nutritionNativeId,
    nutritionPanelNativeId,
    setActiveTabToSuperIngredients,
    setActiveTabToNutrition,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const TABS = {
  SUPER_INGREDIENTS: 'super-ingredients',
  NUTRITION: 'nutrition',
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  hasSuperIngredients: boolean;
};
